import React from 'react';
import LanguageSelector from '../../../shared/LanguageSelector';

const LanguageSelectorMobile = () => <LanguageSelector mobile />;

export default LanguageSelectorMobile;
